import { FC } from 'react';
import { useNavigate } from 'react-router';
import { useQuery } from '@tanstack/react-query';
import { LeaguePreviewCard } from '@dreamteam-monorepo/ui';
import { fetchLeaderboard } from '@/lib/network';
import { useCurrentTournamentCalendar } from '@/hooks/useCurrentTournamentCalendar';
import { useLeaderboardPeriods } from '@/hooks/useLeaderboardPeriods';
import { trackFantasyEvent } from '@/analytics/fantasyEventTracking';

const formatNumber = (n: number) => n.toLocaleString('en-GB');

export const GlobalLeaderboardCard: FC = () => {
  const navigate = useNavigate();

  const { data: activeTournament } = useCurrentTournamentCalendar();
  const tournamentCalendarId = activeTournament?.id ?? null;

  const { data: periodsData } = useLeaderboardPeriods(tournamentCalendarId);

  const periodType = periodsData?.type ?? 'gameweek';

  const { data: overallLeaderboard } = useQuery({
    queryKey: [
      'leaderboard',
      { tournament_calendar: tournamentCalendarId, type: periodType, limit: 1 },
    ],
    queryFn: async () => {
      if (!tournamentCalendarId) {
        return null;
      }
      const res = await fetchLeaderboard({
        tournament_calendar: tournamentCalendarId,
        type: periodType,
        limit: 1,
      });
      return res.data;
    },
    enabled: !!tournamentCalendarId && !!periodsData,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  const globalRank = overallLeaderboard?.user_position?.team_rank;

  return (
    <LeaguePreviewCard
      type="cash"
      cashSwirlSrc="/leagues/yellow-bg-swirl.svg"
      name="Overall Leaderboard"
      rank={globalRank != null ? formatNumber(globalRank) : undefined}
      onViewLeague={() => {
        trackFantasyEvent('leagueLink', { link_name: 'View Global Leaderboard' });
        navigate('/leaderboard');
      }}
      className="shadow-[0px_4px_24px_0px_rgba(34,37,38,0.12)]"
    />
  );
};
